module.exports = __webpack_public_path__ + "static/media/d-john-2.5cb56a57.jpg";